<template>
  <div class="flex items-center space-x-2">
    <lf-input
      :name="`${name}-name`"
      :data-cy="`${name}-name`"
      :value="parameter.name"
      :placeholder="$t('COMMON.NAME')"
      no-margin
      @key-released="updateParameter('name', $event)"
    />
    <lf-dropdown
      :options="WorkflowWebhookParameterType"
      :value="parameter.type || WorkflowWebhookParameterType.String"
      :name="$t('COMMON.TYPE')"
      :data-cy="`${name}-type`"
      :placeholder="$t('COMMON.TYPE')"
      @change="updateParameter('type', $event.toString().toLowerCase())"
    />
    <lf-dropdown
      v-if="parameter.type === WorkflowWebhookParameterType.Boolean"
      :options="WorkflowWebhookParameterBooleanValue"
      :value="parameter.value?.toString()"
      :name="`value-${name}`"
      :placeholder="$t('COMMON.VALUE')"
      @change="updateParameter('value', $event.toString().toLowerCase())"
    />
    <lf-input
      v-else
      :name="`${name}-value`"
      :data-cy="`${name}-value`"
      :value="parameter.value?.toString()"
      :placeholder="$t('COMMON.VALUE')"
      no-margin
      @key-released="updateParameter('value', $event)"
    />
    <button
      v-tooltip="`${$t('COMMON.DELETE')} ${$t('COMMON.PARAMETER')}`"
      type="button"
      class="w-fit-content justify-self-end rounded-4 p-2"
      data-cy="delete-parameter"
      @click="emit('parameter:delete')"
    >
      <icon-base :icon="IconDelete" />
    </button>
  </div>
</template>
<script setup lang="ts">
import {
  WorkflowWebhookParameterBooleanValue,
  WorkflowWebhookParameterType,
} from "@/enums/workflows";
import { getWebhookParameterValue } from "@/helpers/workflow";

import IconDelete from "@/components/icons/IconDelete.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";
import LfInput from "@/components/ui/inputs/LfInput.vue";

import type { WorkflowWebhookParameter } from "@/models/workflows";

const { parameter, name } = defineProps<{
  parameter: WorkflowWebhookParameter;
  name: string;
}>();

const emit = defineEmits<{
  "parameter:change": [WorkflowWebhookParameter];
  "parameter:delete": [];
}>();

const updateParameter = (
  key: keyof WorkflowWebhookParameter,
  value: string
) => {
  const changeType = key === "type";

  if (changeType) {
    emit("parameter:change", {
      ...parameter,
      value: "",
      [key]: value as WorkflowWebhookParameterType,
    });
    return;
  }

  emit("parameter:change", {
    ...parameter,
    [key]:
      key === "value" ? getWebhookParameterValue(parameter.type, value) : value,
  });
};
</script>
